<template>
<div ref="root">
  <slot></slot>
</div>


</template>

<script>
import {MDCMenu} from '@material/menu';
import {ref,onMounted} from "vue";

export default {
  name: "mdc-menu",
  setup() {
    const root = ref();

    onMounted(() => {
      const trigger = root.value.querySelector('.mdc-menu-trigger');
      const target = root.value.querySelector('.mdc-menu-target');

      try {
        if (!trigger) {
          throw "The component mdc-menu need a trigger element with class mdc-menu-trigger inside";
        }
        if (!target) {
          throw "The component mdc-menu need a target element with class mdc-menu-target inside";
        }

        const menu = new MDCMenu(target);

        trigger.addEventListener('click', (e) => {
          //e.preventDefault();
          menu.open=!menu.open;
          /* *
          document.body.addEventListener(
              'click', e => e.stopPropagation(),
              {capture: true, once: true}
          );

         /*  */
        })

      } catch (e) {
        console.error(e)
      }
    })

    return {
      root
    };
  }
}
</script>

<style scoped>

</style>
